export const LOCALE_AUTONYMS: Record<string, string> = {
  en: "English",
  "fr-fr": "Français",
  "de-de": "Deutsch",
  "es-la": "Español (Latinoamérica)",
  "pt-br": "Português (Brasil)",
  "ja-jp": "日本語",
};

export interface EnglishFallbackNoticeCopy {
  message: string;
  action: string;
  dismiss: string;
}

export const ENGLISH_FALLBACK_NOTICE: Record<
  string,
  EnglishFallbackNoticeCopy
> = {
  "fr-fr": {
    message: "Cette page n'est disponible qu'en anglais pour le moment.",
    action: "Retour à Français",
    dismiss: "Fermer",
  },
  "de-de": {
    message: "Diese Seite ist momentan nur auf Englisch verfügbar.",
    action: "Zurück zu Deutsch",
    dismiss: "Schließen",
  },
  "es-la": {
    message: "Esta página solo está disponible en inglés por ahora.",
    action: "Volver a Español (Latinoamérica)",
    dismiss: "Cerrar",
  },
  "pt-br": {
    message: "Esta página está disponível apenas em inglês por enquanto.",
    action: "Voltar para Português (Brasil)",
    dismiss: "Fechar",
  },
  "ja-jp": {
    message: "このページは現在英語版のみです。",
    action: "日本語に戻る",
    dismiss: "閉じる",
  },
};
